export function MapPinIcon() {
  return (
    <svg width="13" height="15" viewBox="0 0 13 15" fill="none">
      <path
        d="M6.5 1C4.01 1 2 3.01 2 5.5C2 8.75 6.5 14 6.5 14C6.5 14 11 8.75 11 5.5C11 3.01 8.99 1 6.5 1Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
      <circle
        cx="6.5"
        cy="5.5"
        r="1.4"
        stroke="currentColor"
        strokeWidth="1.2"
      />
    </svg>
  )
}
